import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';


export const assignmentsApi = createApi({
    reducerPath: "assignmentsApi",
    baseQuery,
    endpoints: (builder) => ({
        getAssignments: builder.query({
            query: ({ page, limit, startDate, endDate, teamLeads, laborers, status, site_id }) => {

                const queryParams = new URLSearchParams({
                    page,
                    limit,
                });

                if (laborers.length > 0) {
                    queryParams.append('laborers_ids', JSON.stringify(laborers));
                }

                if (teamLeads.length > 0) {
                    queryParams.append('team_ids', JSON.stringify(teamLeads));
                }

                if (status) {
                    queryParams.append('status', status);
                }

                if (startDate) {
                    queryParams.append('start_date', startDate);
                }

                if (endDate) {
                    queryParams.append('end_date', endDate);
                }

                const apiUrl = `site/v1/${site_id}/assignments?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["assignments"],
        }),
        getAllAssignments: builder.mutation({
            query: ({ page, limit, startDate, endDate, teamLeads, laborers, status, site_id }) => {

                const queryParams = new URLSearchParams({
                    page,
                    limit,
                });

                if (laborers.length > 0) {
                    queryParams.append('laborers_ids', JSON.stringify(laborers));
                }

                if (teamLeads.length > 0) {
                    queryParams.append('team_ids', JSON.stringify(teamLeads));
                }

                if (status) {
                    queryParams.append('status', status);
                }

                if (startDate) {
                    queryParams.append('start_date', startDate);
                }

                if (endDate) {
                    queryParams.append('end_date', endDate);
                }

                const apiUrl = `site/v1/${site_id}/assignments?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["assignments"],
        }),
        clockInAssignments: builder.mutation({
            query: ({body,site_id}) => ({
                url: `site/v1/${site_id}/assignments/clock-in`,
                method: "POST",
                body
            }),
            invalidatesTags: ["assignments"],
        }),
        clockOutAssignments: builder.mutation({
            query: ({body,site_id}) => ({
                url: `site/v1/${site_id}/assignments/clock-out`,
                method: "POST",
                body
            }),
            invalidatesTags: ["assignments"],
        }),
    }),
});

export const { useGetAssignmentsQuery, useGetAllAssignmentsMutation,useClockInAssignmentsMutation,useClockOutAssignmentsMutation } = assignmentsApi;

